<div [class.button-mode]="type == 'button'">
  <mat-form-field appearance="outline" floatLabel="always" class="mat-select-form-field dropdown-field">
    <mat-select
      [disabled]="disabledSelector || disabled"
      [placeholder]="placeholder"
      [(value)]="selectedValue"
      #selector
      (closed)="selectorClosed()"
      (opened)="selectorOpened()"
    >
      <mat-select-trigger>
        {{ selectedValue?.name }}
      </mat-select-trigger>
      <div class="main-item-picker-container">
        <div class="main-item-picker-search">
          <mat-form-field appearance="outline" appThrottleClick>
            <input
              matInput
              type="search"
              placeholder="Search..."
              [(ngModel)]="search"
              (keydown)="$event.stopPropagation()"
            />
          </mat-form-field>
        </div>
        <div class="main-item-picker-items">
          <mat-option
            *ngFor="let item of data | filter: search"
            [value]="item"
            (click)="onClick(item)"
            (keydown.enter)="onClick(item)"
            (keyup)="keyup()"
          >
            <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
            <span>{{ item.name }}</span>
          </mat-option>
        </div>
      </div>
      <div class="item-picker-footer" *ngIf="showCreateButton">
        <mat-divider></mat-divider>
        <mat-option (click)="create.emit()">
          <span class="create-button" color="primary">{{ createButtonText }}</span>
        </mat-option>
      </div>
    </mat-select>
  </mat-form-field>
  <button
    mat-flat-button
    type="button"
    class="mat-secondary-button"
    (click)="openSelector(selector)"
    [disabled]="disabled"
  >
    {{ placeholder }}
  </button>
</div>
